import React from 'react';
import type { UserProfileDetail } from '../types/userDetail.types';
import { SideItem } from './WorkStatusCard';

export function EmergencyContactCard({ user }: { user: UserProfileDetail }) {
 return (
 <div className="bg-white rounded-md p-6 border border-slate-100">
 <h3 className="sm:text-sm text-xs text-slate-800 mb-6">Thông tin liên hệ khẩn cấp</h3>

 <div className="space-y-4">
 <SideItem label="Họ và tên" value={`${user.emergency_contact_name} (${user.emergency_contact_relationship})`} />
 <SideItem label="Số điện thoại" value={user.emergency_contact_phone} isMasked />
 <SideItem label="Mối quan hệ" value={user.emergency_contact_relationship} />
 </div>
 </div>
 );
}
